export default __webpack_public_path__ + "static/media/our-approach-tablet.20861d46.png";